const FemaleSymbolIcon = /*#__PURE__*/ [
  ["path", { d: "M12 14C15.3137 14 18 11.3137 18 8C18 4.68629 15.3137 2 12 2C8.68629 2 6 4.68629 6 8C6 11.3137 8.68629 14 12 14ZM12 14V22M9 19H15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { FemaleSymbolIcon as default };
//# sourceMappingURL=FemaleSymbolIcon.js.map
